'use client';

import React, { useMemo } from 'react';

import { type SearchPageCommonWrapperData } from '@/app/components/search/SearchMain.tsx';

export const SearchPageCommonWrapperContext = React.createContext<SearchPageCommonWrapperData>(
  {} as SearchPageCommonWrapperData
);

export default function SearchPageWrapperDataProvider({
  searchPageCommonWrapperData,
  children,
}: {
  searchPageCommonWrapperData: SearchPageCommonWrapperData;
  children: React.ReactNode;
}) {
  const contextValue = useMemo(() => searchPageCommonWrapperData, [searchPageCommonWrapperData]);
  return (
    <SearchPageCommonWrapperContext.Provider value={contextValue}>{children}</SearchPageCommonWrapperContext.Provider>
  );
}

export const useSearchPageWrapperData = () => React.useContext(SearchPageCommonWrapperContext);
